import { MENU_RESPONSE } from "../../Constants";

const INITIAL_STATE = {
    menu: [],
};

const menuReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MENU_RESPONSE:
            return { ...state, menu: action.payload }
        default:
            return state;
    }
};

export default menuReducer;